import { render, staticRenderFns } from "./ViewGrid.vue?vue&type=template&id=7b96a104"
import script from "./ViewGrid.vue?vue&type=script&lang=js"
export * from "./ViewGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports